import React from "react";
import { Link, useParams } from 'react-router-dom'
import { useState, useEffect, Component }  from "react";
import RecrutmentForm from "./RecrutmentForm";
import {getTranslations} from './Translations'

import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha
} from 'react-google-recaptcha-v3';

let translations;

class Tender extends Component {

    getQueryVariable = function(variable)
    {
            var query = window.location.search.substring(1);
            console.log(query)
            var vars = query.split("&");
            console.log(vars)
            for (var i=0;i<vars.length;i++) {
                var pair = vars[i].split("=");
                if(pair[0] == variable){
                  return pair[1];
                }
            }
            return(false);
    }

    componentDidMount() {
      const id = this.props.match?.params?.id ?? this.getQueryVariable('id');
      translations =  getTranslations(window?.HRMRecruitmentComponentConfiguration?.language);
      console.log(JSON.stringify(this.props));
      const apiUrl = window.HRMRecruitmentComponentConfiguration?.apiUrl;
      const language = window.HRMRecruitmentComponentConfiguration?.language;
       fetch((apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl) + "/ExternalApi/GetJobPositionTenderDetailsForm?tenderId="+id+"&language=" +language, {
         method: "GET"
       })
      .then(res => res.json()).then((result) => {
        if(result.Status == "Error" || result.Status == "Error_TenderNotExistingOrNotActive")
        {
          this.setState(null);
          alert(result.Message);
        }
        else
        {
          console.log(result);
          this.setState(result.Data);
        }
        },(error) => {
          console.log(error);
          alert(translations.error);
        }
      )      
    }

    render() {
      return (
        <div key={this.state?.Tender?.Id} className="tender-details">
          <Link to={{pathname: "/"}} className="back-to-list">{translations?.listOfTenders}</Link>
          <h1 className="tender-name">{this.state?.Tender[0].Name}</h1>        
          <div className="tender-description" dangerouslySetInnerHTML={{ __html: this.state?.Tender[0].Description }} />

          <GoogleReCaptchaProvider reCaptchaKey={window.HRMRecruitmentComponentConfiguration.captchaSiteKey}>
              <RecrutmentForm selectedTender={this.state} />
          </GoogleReCaptchaProvider>

         
        </div>
      );
    };
}

export default Tender;
